import { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { WelletContext } from '../../context/WelletContext';
import GafeteFileUpload from '../../components/GafeteFileUpload/GafeteFileUpload';
import ContentApp from '../../components/ContentApp';
import Header from '../../components/Common/Header/Header';
import Button from '../../components/Common/Button/Button';
import ErrorBox from '../../components/Common/ErrorBox/ErrorBox';
import { setWorkCredential } from '../../actions/workCredentialActions';

const GafeteConcierge = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorFile, setErrorFile] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const welletContext = useContext(WelletContext);
  const kycStatus = useSelector((state) => state.associates.user.kycStatus);
  const handleFileSelect = (files) => {
    setErrorFile('');
    setSelectedFiles(files);
  };

  const filesToBase64 = (files) => {
    return Promise.all(
      files.map(
        (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = (error) => reject(error);
          }),
      ),
    );
  };

  const handleContinue = async () => {
    if (!selectedFiles || selectedFiles.length === 0) {
      return setErrorFile('Debes subir al menos un archivo.');
    }

    setIsLoading(true);

    const workCredentialBase64 = await filesToBase64(selectedFiles);

    dispatch(setWorkCredential(workCredentialBase64));

    try {
      await welletContext.apis.tickets.put('users/work-credentials', {
        Credentials: workCredentialBase64,
      });
    } catch (err) {
      setIsLoading(false);
      return setErrorFile('Hubo un error al subir los documentos.');
    }

    setIsLoading(false);

    history.push('/account-verification');
  };

  return (
    <>
      <Header title={t('Validación Profesional')} />

      <ContentApp classes='pt-0'>
        <div className='text-lighter-gray mb-3 font-small'>{t('uploadDocumentation')}</div>

        <GafeteFileUpload onFileSelect={handleFileSelect} />

        {errorFile && (
          <div className='mt-3'>
            <ErrorBox title={errorFile} />
          </div>
        )}

        {selectedFiles.length > 0 && (
          <div className='mt-4'>
            <Button
              iconColor='#000'
              size='large'
              text={isLoading ? t('sending') : t('continue')}
              loading={isLoading}
              icon={!isLoading}
              typeIcon='arrow'
              onClick={handleContinue}
            />
          </div>
        )}
      </ContentApp>
    </>
  );
};

export default GafeteConcierge;
